export const validateEmailAndPassword = (
  validate: (json: object) => any,
  fields: object,
): Promise<any> =>
  validate(fields).prop('email').required().email().prop('password').required().simplePassword()
    .promise;
